import { shortABTestRouteConfig } from '@/config/abTestConfig'
import { navigateToNextOnboardingPage } from '@app-studio-web/ui/helpers/abTestRouting'
import { trackOnboardingFormData } from '@app-studio-web/ui/helpers/snowplowTracking'

export default async function navigateToNextShortOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  const formData = await request.formData()

  trackOnboardingFormData({
    formData,
    orderedRoutes: shortABTestRouteConfig.baseline,
    url: request.url,
  })

  return navigateToNextOnboardingPage({
    redirectOnComplete: '/sign-up/company',
    request,
    routeConfig: shortABTestRouteConfig,
    variant: 'baseline',
  })
}
